import script from "./addPotentialFromEmail.vue?vue&type=script&setup=true&lang=ts"
export * from "./addPotentialFromEmail.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__